// extracted by mini-css-extract-plugin
module.exports = {"container":"LeaveTypeList_container__3fBpM"};